module.exports = __webpack_public_path__ + "img/katarina_amenities_9.668eaad0.jpg";